package com.arena_web.ui.localization

object AppStringsFR : AppStrings {

    // language selector
    override val headerProfileLanguage = "Langue"
    override val headerProfileLanguageRecommended = "Recommandé"

    // common
    override val commonSeeAll = "Tout voir"
    override val commonNo = "Non"
    override val commonYes = "Oui"
    override val commonConfirm = "Confirmer"
    override val commonSend = "Envoyer"
    override val commonError = "Erreur"
    override val commonOk = "OK"

    // chat
    override val chatMenuUnmute = "Réactiver le son"
    override val chatMenuMute = "Mettre en sourdine"
    override val chatMenuInviteMembers = "Inviter des membres"
    override val chatMenuLeaveGroup = "Quitter le groupe"
    override val chatMenuDeleteChat = "Supprimer le chat"
    override fun chatRemoveMemberTitle(name: String) = "Retirer $name ?"
    override fun chatRemoveMemberWarning(name: String) = "Retirer $name du groupe ? Cette action est irréversible."
    override val chatRemoveMemberAction = "Retirer"
    override val chatDefaultName = "Chat"
    override fun chatTypingOne(name: String) = "$name écrit..."
    override fun chatTypingMany(count: Int) = "$count personnes écrivent..."
    override fun chatMembersCount(count: Int) = "$count membres"
    override fun chatMembersCountOnline(count: Int, online: Int) = "$count membres, $online en ligne"
    override val chatOnline = "En ligne"
    override val chatOffline = "Hors ligne"
    override val chatEditCommunityTitle = "Modifier la communauté"
    override val chatCommunityNameLabel = "Nom de la communauté"
    override val chatCommunityNamePlaceholder = "Saisis le nom de la communauté..."
    override val chatSaving = "Enregistrement..."
    override val chatMessageInputPlaceholder = "Écris un message..."
    override val chatInviteMembersTitle = "Inviter des membres"
    override val chatSearchFriendsPlaceholder = "Rechercher des amis..."
    override val chatNoFriendsToInvite = "Aucun ami à inviter"
    override val chatNoResults = "Aucun résultat"
    override val chatInviting = "Invitation..."
    override val chatInvite = "Inviter"
    override fun chatInviteCount(count: Int) = "Inviter ($count)"
    override val chatPanelTitle = "Arena Chat"
    override val chatSearchPlaceholder = "Rechercher un chat"
    override val chatFilterAll = "Tous"
    override val chatFilterDirect = "Direct"
    override val chatFilterCommunity = "Communauté"
    override val chatNoChatsFound = "Aucun chat trouvé"
    override val chatNoConversationsYet = "Pas encore de conversations"
    override val chatNewChatTitle = "Nouveau chat"
    override val chatTabDirectMessage = "Message direct"
    override val chatTabCommunity = "Communauté"
    override val chatSearchPeoplePlaceholder = "Recherche des personnes que tu suis..."
    override val chatNotFollowingAnyone = "Tu ne suis encore personne"
    override val chatCreating = "Création..."
    override val chatCreateCommunity = "Créer une communauté"
    override val chatSelectConversation = "Sélectionne une conversation"
    override fun chatReplyTo(name: String) = "Répondre à $name"
    override val chatUnknownSender = "Inconnu"
    override val chatUploading = "Envoi en cours..."
    override val chatEditingMessage = "Modification du message"
    override val chatSearchInChatPlaceholder = "Rechercher dans le chat..."
    override fun chatSearchResultsFound(count: Int) = "$count trouvé(s)"
    override val chatGroupInfoTitle = "Infos du groupe"
    override val chatUserInfoTitle = "Infos de l'utilisateur"
    override val chatDeleteChatAction = "Supprimer le chat"
    override val chatDeleteGroupAction = "Supprimer le groupe"
    override val chatLeaveGroupAction = "Quitter le groupe"
    override val chatLastSeenRecently = "vu récemment"
    override val chatNotificationsLabel = "Notifications"
    override val chatTabMembers = "Membres"
    override val chatTabMedia = "Médias"
    override val chatTabFiles = "Fichiers"
    override val chatTabLinks = "Liens"
    override val chatLoading = "Chargement..."
    override val chatNoMediaYet = "Pas encore de médias"
    override val chatNoFilesYet = "Pas encore de fichiers"
    override val chatUnknownFile = "Fichier inconnu"
    override val chatNoLinksYet = "Pas encore de liens"
    override val chatNoMembers = "Aucun membre"
    override val chatRoleOwner = "Propriétaire"
    override val chatRoleAdmin = "Admin"
    override val chatEdited = "modifié"
    override val chatFileFallback = "Fichier"
    override val chatMenuReply = "Répondre"
    override val chatMenuPin = "Épingler"
    override val chatEmptyTitle = "Pas encore de chats"
    override val chatEmptySubtitle = "Lance une conversation pour voir tes messages ici."
    override val chatUnnamed = "Sans nom"
    override val chatNoMessagesYet = "Pas encore de messages"
    override val chatRoomEmptyTitle = "Pas encore de messages"
    override val chatRoomEmptySubtitle = "Dis bonjour pour lancer la conversation."
    override fun chatMembersHeader(count: Int) = "Membres ($count)"
    override val chatNoMediaSharedYet = "Aucun média partagé pour l'instant"
    override val chatNoFilesSharedYet = "Aucun fichier partagé pour l'instant"
    override val chatNoLinksSharedYet = "Aucun lien partagé pour l'instant"

    // widget
    override val widgetDismiss = "Fermer"
    override val widgetSomethingWentWrong = "Une erreur s'est produite"
    override val widgetTryAgain = "Réessayer"
    override val widgetCookieTitle = "Nous utilisons des cookies"
    override val widgetCookieMessage = "Ce site utilise des cookies pour te garantir la meilleure expérience."
    override val widgetCookieDecline = "Refuser"
    override val widgetCookieAccept = "Accepter"
    override val widgetAddInterval = "Ajouter un créneau"
    override val widgetSendMessage = "Envoyer un message"
    override val widgetPrevious = "Précédent"
    override val widgetStatusVip = "VIP"
    override val widgetStatusActive = "Actif"
    override val widgetStatusDebtor = "Débiteur"
    override val widgetStatusInactive = "Inactif"
    override val widgetUnpaid = "impayé"
    override val widgetStatusInProgress = "En cours"
    override val widgetStatusUpcoming = "À venir"
    override val widgetStatusPending = "En attente"
    override val widgetStatusCompleted = "Terminé"
    override fun widgetFieldLabel(number: String) = "Terrain $number"
    override val widgetYearly = "Annuel"
    override val widgetAllFields = "Tous les terrains"
    override val widgetPreviousMonth = "Mois précédent"
    override val widgetNextMonth = "Mois suivant"
    override val widgetSortAscending = "Tri croissant"
    override val widgetSortDescending = "Tri décroissant"
    override val widgetChecked = "Coché"

    // form
    override val formSelectPlaceholder = "Sélectionner..."

    // common
    override val commonCancel = "Annuler"
    override val commonSave = "Enregistrer"
    override val commonDelete = "Supprimer"
    override val commonEdit = "Modifier"
    override val commonNext = "Suivant"
    override val commonRetry = "Réessayer"
    override val commonSearch = "Rechercher"

    // event
    override val eventMatchEndedTitle = "LE MATCH EST TERMINÉ"
    override val eventMatchEndedSubtitle = "Note les joueurs pour mettre à jour leurs classements personnels."
    override val eventTabMatchInfo = "Infos du match"
    override val eventTabLineups = "Compositions"
    override val eventTabMedia = "Médias"
    override val eventCreateTeam = "Créer une équipe"
    override val eventCancelEventQuestion = "Annuler l'événement ?"
    override val eventDeleteEventQuestion = "Supprimer l'événement ?"
    override fun eventWillBeCancelled(eventTitle: String) = "\"$eventTitle\" sera marqué comme annulé."
    override fun eventWillBeDeleted(eventTitle: String) = "\"$eventTitle\" sera définitivement supprimé."
    override val eventCancelNoticeParticipants = "Les autres participants seront prévenus. Le chat et l'historique restent disponibles."
    override val eventDeleteNoticeMedia = "L'image de l'événement et le chat seront aussi supprimés."
    override val eventKeepEvent = "Garder l'événement"
    override val eventCancelling = "Annulation..."
    override val eventDeleting = "Suppression..."
    override val eventCancelEvent = "Annuler l'événement"
    override val eventMatchPerformanceTitle = "Performance du match"
    override val eventProPlusLabel = "Pro⁺"
    override val eventStatLabel = "Statistique"
    override val eventProPlusStatDescription = "Précision des tirs, réussite des passes et possession de balle détaillées."
    override val eventLoadingMedia = "Chargement des médias..."
    override val eventDeleteMediaQuestion = "Supprimer le média ?"
    override val eventDeleteMediaMessage = "Ce fichier sera retiré de l'événement pour tout le monde."
    override val eventNoMediaYet = "Pas encore de médias"
    override val eventNoMediaDescription = "Les photos et vidéos de ce match apparaîtront ici."
    override val eventInviteTeamTitle = "Inviter une équipe"
    override val eventSearchTeamsLabel = "Rechercher des équipes"
    override val eventSearchTeamsPlaceholder = "Saisis le nom de l'équipe..."
    override val eventSearching = "Recherche..."
    override val eventNoTeamsFound = "Aucune équipe trouvée"
    override fun eventTeamRating(rating: String) = "Note $rating"
    override fun eventTeamMembersCount(count: Int) = "$count membres"
    override val eventInviteStatusAccepted = "Acceptée"
    override val eventInviteStatusDeclined = "Refusée"
    override val eventInviteStatusInvited = "Invitée"
    override val eventInvite = "Inviter"
    override val eventStartEventQuestion = "Démarrer l'événement ?"
    override fun eventWillGoLive(eventTitle: String) = "\"$eventTitle\" passera en direct."
    override val eventStartNotice = "Les inscriptions seront fermées et le match commencera."
    override fun eventPendingRequestOne(count: Int) = "$count demande en attente"
    override fun eventPendingRequestsMany(count: Int) = "$count demandes en attente"
    override val eventPendingRequestsSubtitle = "Ces joueurs ont demandé à rejoindre mais n'ont pas encore été approuvés."
    override fun eventPlayersWithoutTeamOne(count: Int) = "$count joueur sans équipe"
    override fun eventPlayersWithoutTeamMany(count: Int) = "$count joueurs sans équipe"
    override val eventTeamlessSubtitle = "Ils sont confirmés mais ne sont assignés à aucune équipe."
    override val eventStarting = "Démarrage..."
    override val eventStartAnyway = "Démarrer quand même"
    override val eventMonthJanuary = "Janvier"
    override val eventMonthFebruary = "Février"
    override val eventMonthMarch = "Mars"
    override val eventMonthApril = "Avril"
    override val eventMonthMay = "Mai"
    override val eventMonthJune = "Juin"
    override val eventMonthJuly = "Juillet"
    override val eventMonthAugust = "Août"
    override val eventMonthSeptember = "Septembre"
    override val eventMonthOctober = "Octobre"
    override val eventMonthNovember = "Novembre"
    override val eventMonthDecember = "Décembre"
    override val eventVs = "vs"
    override val eventTeamsLabel = "équipes"
    override val eventPlayersLabel = "joueurs"
    override val eventProBadge = "PRO"
    override val eventCompletedBadge = "Terminé"
    override val eventLeadersEmptyWinGame = "Gagne une partie pour grimper au classement."
    override val eventLeadersEmptyFirstScore = "Sois le premier à marquer et prends la tête du classement."
    override val eventLeadersEmptyTakeSet = "Remporte un set pour t'emparer de la première place."
    override val eventLeadersEmptyFirstAssist = "Sois le premier à délivrer une passe décisive."
    override fun eventTopStat(name: String) = "Top $name"
    override val eventPlayerFallback = "Joueur"
    override val eventCreateTeamSubtitle = "Prépare ton équipe pour le match"
    override val eventTeamNameLabel = "Nom de l'équipe"
    override val eventTeamNameRequired = "Le nom de l'équipe est requis"
    override val eventTeamColorLabel = "Couleur de l'équipe"
    override val eventTeamColorSubtitle = "Choisis la couleur de ton équipe"
    override val eventTeamNamePlaceholder = "Saisis le nom de l'équipe..."
    override val eventChatTitle = "Chat"
    override val eventChatLive = "Live"
    override val eventChatPlayersLabel = "Joueurs"
    override val eventChatWaitingApproval = "En attente d'approbation"
    override val eventChatConfirmingSpot = "Confirmation de ta place"
    override val eventChatLocked = "Le chat est verrouillé"
    override val eventChatWaitingApprovalSubtitle = "Dès que l'admin confirme ta demande, tu pourras discuter avec l'équipe."
    override val eventChatConfirmingSpotSubtitle = "Ta demande est en cours de traitement. Le chat se débloque dès que tu es dedans."
    override val eventChatPrivateSubtitle = "C'est un événement privé. Demande à rejoindre et attends l'approbation de l'admin."
    override val eventChatLockedSubtitle = "Tu dois rejoindre ce match pour voir la conversation et discuter avec les autres joueurs."
    override val eventJoinEvent = "Rejoindre l'événement"
    override val eventChatNoMessages = "Pas encore de messages"
    override val eventChatNoMessagesSubtitle = "Lance la conversation avec ton équipe."
    override val eventTeamSectionTitle = "Équipe"
    override val eventDeleteTeam = "Supprimer l'équipe"
    override val eventViewProfile = "Voir le profil"
    override val eventRemoveAdmin = "Retirer l'admin"
    override val eventMakeAdmin = "Nommer admin"
    override val eventRemoveFromTeam = "Retirer de l'équipe"
    override val eventRemoveFromEvent = "Retirer de l'événement"
    override fun eventFormatVs(format: Int) = "$format vs $format"
    override fun eventTeamsCount(count: Int) = "$count équipes"
    override fun eventPlayersOfMax(joined: Int, max: Int) = "$joined / $max joueurs"
    override fun eventPlayersCount(count: Int) = "$count joueurs"
    override val eventStatusLive = "Live"
    override val eventLeave = "Quitter"
    override val eventStart = "Démarrer"
    override val eventJoin = "Rejoindre"
    override val eventStatusPending = "En attente"
    override val eventStatusCanceled = "Annulé"
    override val eventPendingApprovalBadge = "En attente d'approbation"
    override val eventRatePerformanceTitle = "Noter la performance"
    override val eventRateVoteCounts = "Ton vote compte !"
    override val eventCommunityRating = "Note de la communauté"
    override val eventSubmitRating = "Envoyer la note"
    override val eventSubmitting = "Envoi..."
    override val eventAddMediaTitle = "Ajouter des médias"
    override val eventUploadMedia = "Importer des médias"
    override val eventDropMediaHere = "Dépose ta photo et ta vidéo ici"
    override val eventMaxFileSize = "30 Mo max"
    override val eventSelectedLabel = "Sélectionnés"
    override val eventClearAll = "Tout effacer"
    override val eventAddToTeam = "Ajouter à l'équipe"
    override val eventMakeSubstitution = "Faire un remplacement"
    override val eventViewProfileSheet = "Voir le profil"
    override fun eventSwapWith(name: String) = "Remplacer $name par"
    override val eventEndMatch = "Terminer le match"
    override val eventReset = "Réinitialiser"
    override val eventLeadersEmptyWinGameShort = "Gagne une partie pour grimper au classement"
    override val eventLeadersEmptyScoreFirst = "Marque en premier pour prendre la tête du classement"
    override val eventLeadersEmptyTakeSetShort = "Remporte un set pour t'emparer de la première place"
    override val eventLeadersEmptyWinningAssist = "Fais la passe décisive"
    override val eventRatePlayersSubtitle = "Note les joueurs pour mettre à jour le classement"
    override val eventGenericError = "Une erreur s'est produite"
    override val eventDeleteTeamQuestion = "Supprimer l'équipe ?"
    override fun eventDeleteTeamMessage(teamName: String) = "\"$teamName\" sera retirée de cet événement. Les joueurs qui y étaient assignés deviennent non assignés."
    override val eventPlayersTitle = "Joueurs"
    override fun eventApprovedCount(confirmed: Int, total: Int) = "($confirmed/$total approuvés)"
    override val eventAwaitingPlayers = "En attente de joueurs"
    override val eventAwaitingPlayersSubtitle = "Rejoins l'événement maintenant pour commencer à former les équipes."
    override val eventAssignToTeam = "Assigner à une équipe"
    override val eventFormatLabel = "Format :"
    override val eventProLabel = "Pro"
    override val eventTimeline = "Chronologie"
    override val eventFormatAuto = "Auto"
    override val eventCoach = "Coach"
    override val eventSaving = "Enregistrement..."
    override val eventCreating = "Création..."
    override val eventSaveChanges = "Enregistrer les modifications"
    override val eventCreateEvent = "Créer l'événement"
    override val eventEditEventTitle = "Modifier l'événement"
    override val eventErrorTitleRequired = "Le titre est requis"
    override val eventErrorSportRequired = "Le sport est requis"
    override val eventErrorSportNameRequired = "Le nom du sport est requis"
    override val eventErrorFormatRequiredPro = "Le format est requis pour les événements Pro"
    override val eventErrorStartTimeRequired = "L'heure de début est requise"
    override val eventErrorEndTimeRequired = "L'heure de fin est requise"
    override val eventErrorEndAfterStart = "L'heure de fin doit être après l'heure de début"
    override val eventErrorStartInPast = "L'heure de début ne peut pas être dans le passé"
    override val eventErrorSelectAddress = "Sélectionne une adresse"
    override val eventErrorAddressCity = "Choisis une adresse valide qui inclut une ville"
    override val eventErrorCoverRequired = "La photo de couverture est requise"
    override val eventErrorSignInEdit = "Connecte-toi pour modifier des événements"
    override val eventErrorSignInCreate = "Connecte-toi pour créer des événements"
    override val eventErrorUploadImage = "Impossible d'envoyer l'image"
    override val eventErrorSaveChanges = "Impossible d'enregistrer les modifications"
    override val eventErrorCreateEvent = "Impossible de créer l'événement"
    override val eventAddressLabel = "Adresse"
    override val eventAddressPlaceholder = "Rechercher une adresse..."
    override val eventTitleLabel = "Titre"
    override val eventTitlePlaceholder = "ex. Match de foot du dimanche"
    override val eventSportNameLabel = "Nom du sport"
    override val eventSportNamePlaceholder = "Saisis le nom du sport"
    override val eventMaxPlayersLabel = "Joueurs max"
    override val eventMaxPlayersPlaceholder = "ex. 20"
    override val eventDateLabel = "Date"
    override val eventTimeFromLabel = "De"
    override val eventTimeToLabel = "À"
    override val eventChooseOnMap = "Choisir sur la carte"
    override val eventConfirmLocation = "Confirmer le lieu"
    override val eventAddPhoto = "Ajouter une photo"
    override val eventSportLabel = "Sport"
    override val eventLoading = "Chargement..."
    override val eventSelectSportPlaceholder = "Sélectionne un sport"
    override val eventCommunityLabel = "Communauté"
    override val eventCommunityNone = "Aucune (public)"
    override val eventUnnamedGroup = "Groupe sans nom"
    override val eventFormatFieldLabel = "Format"
    override val eventSelectPlaceholder = "Sélectionner"
    override val eventCostLabel = "Coût"
    override val eventPrivateLabel = "Privé"
    override val eventPrivateInfoDescription = "Gère ton équipe en approuvant manuellement les demandes ou en retirant des participants."

    // wallet
    override val walletTopUpTitle = "Recharger le portefeuille"
    override val walletSelectAmount = "Sélectionne un montant"
    override val walletOr = "ou"
    override val walletCustomAmount = "Montant personnalisé"
    override val walletEnterAmountPlaceholder = "Saisis le montant"
    override val walletProcessing = "Traitement…"
    override val walletTopUpAction = "Recharger"

    // nav
    override val navDashboard = "Tableau de bord"
    override val navClients = "Clients"
    override val navChat = "Chat"
    override val navSchedule = "Planning"
    override val navClubSettings = "Paramètres du club"
    override val navArena = "Arena"
    override val navFeed = "Fil"
    override val navPeople = "Joueurs"
    override val navProfile = "Profil"
    override val navStatistic = "Statistiques"
    override val navTeam = "Équipe"
    override val navMedia = "Médias"
    override val navWeek = "Semaine"
    override val navMonth = "Mois"
    override val navYear = "Année"

    // modal
    override val modalDecline = "Refuser"
    override val modalCompleteSession = "Terminer la session"
    override val modalTimeAlt = "Heure"
    override val modalPriceAlt = "Prix"
    override val modalBookings = "Réservations"
    override val modalTotalSpent = "Total dépensé"
    override val modalSendMessage = "Envoyer un message"
    override val modalAddNote = "Ajouter une note"
    override val modalAdminNotes = "Notes admin"
    override val modalAdminNotesPrivacy = "Privé – visible uniquement par les admins"
    override val modalWriteNotePlaceholder = "Écris une note..."
    override val modalAdd = "Ajouter"
    override val modalBookingHistory = "Historique des réservations"
    override val modalNoBookingsYet = "Pas encore de réservations"
    override val modalFieldFallback = "Terrain"
    override val modalStatusConfirmed = "Confirmée"
    override val modalStatusPending = "En attente"
    override val modalStatusCompleted = "Terminée"
    override val modalStatusCancelled = "Annulée"
    override val modalPaid = "Payée"
    override val modalUnpaid = "Impayée"

    // feed
    override val feedClubBadge = "Club"
    override fun feedAddAllPhotos(count: Int) = "Ajouter les $count photo(s)"
    override val feedUploadFailed = "Échec de l'envoi"
    override val feedCreatePostFailed = "Impossible de créer le post"
    override val feedCreatePostTitle = "Créer un post"
    override val feedChooseLayoutSubtitle = "Choisis une mise en page pour ton post"
    override val feedFileTooLarge = "Fichier trop volumineux (50 Mo max)"
    override val feedChooseLayout = "Choisir une mise en page"
    override val feedCreating = "Création..."
    override val feedAddPhoto = "Ajouter une photo"
    override val feedCityLabel = "Ville"
    override val feedEnterCityPlaceholder = "Saisis le nom de la ville..."
    override val feedPostContentLabel = "Contenu du post"
    override val feedPostContentPlaceholder = "Écris quelque chose sur ce post..."
    override val feedOptional = "(Optionnel)"
    override val feedPickPhotoFirst = "Choisis d'abord une photo"
    override val feedCreateStoryFailed = "Impossible de créer la story"
    override val feedCreateStoriesTitle = "Créer des stories"
    override val feedCreateStoriesSubtitle = "Crée et partage tes moments"
    override val feedFileTooLargeStory = "Fichier trop volumineux (30 Mo max)"
    override val feedDropContentHere = "Dépose ton contenu ici"
    override val feedMaxStorySize = " 30 Mo max"
    override val feedFollowingSection = "Abonnements"
    override val feedFollowersSection = "Abonnés"
    override val feedSearching = "Recherche…"
    override val feedNoResults = "Aucun résultat"
    override val feedLoadingMore = "Chargement…"
    override val feedThisUser = "cet utilisateur"
    override fun feedUnfollowTitle(name: String) = "Ne plus suivre $name ?"
    override val feedUnfollowSubtitle = "Tu peux te réabonner à tout moment."
    override val feedUnfollow = "Ne plus suivre"
    override fun feedRemoveTitle(name: String) = "Retirer $name ?"
    override val feedRemoveSubtitle = "La personne ne sera pas prévenue, mais ne verra plus tes posts."
    override val feedRemove = "Retirer"
    override val feedFollow = "Suivre"
    override val feedDeleted = "Supprimé"
    override val feedNotFollowingTitle = "Tu ne suis encore personne"
    override val feedNotFollowingBody = "Suis des joueurs pour voir leurs derniers posts de match, highlights et stories dans ton fil."
    override val feedNoFollowersTitle = "Pas encore d'abonnés"
    override val feedNoFollowersBody = "Partage tes posts de match et tes stories pour te faire remarquer par la communauté."
    override val feedDiscoverPlayers = "Découvrir des joueurs"

    // dropdown
    override val dropdownAllCities = "Toutes les villes"
    override val dropdownSelectedAlt = "Sélectionné"

    // page
    override val pageScheduleTitle = "Planning"
    override val pageScheduleComingSoon = "La vue planning arrive bientôt"
    override val pageEventsSeoTitle = "Événements sportifs"
    override val pageEventsSeoDescription = "Parcours et rejoins des événements sportifs près de chez toi — football, tennis, basketball, padel et plus. Crée ta propre partie et invite des joueurs sur Arena."
    override val pageEventsTitle = "Événements"
    override val pageCreateEvent = "Créer un événement"
    override val pageNoEventsYet = "Pas encore d'événements"
    override val pageNotFoundTitle = "Oups, page introuvable"
    override val pageNotFoundBody = "Vérifie l'adresse de la page ou retourne à l'arène principale."
    override val pageBackToArena = "Retour à l'Arena"
    override val pageChatTitle = "Chat"
    override val pageLoading = "Chargement..."
    override val pageSomethingWentWrong = "Une erreur s'est produite"
    override fun pageUnfollowTitle(name: String) = "Ne plus suivre $name"
    override val pageRemoveFollowerTitle = "Retirer l'abonné ?"
    override fun pageRemoveFollowerSubtitle(name: String) = "Nous ne préviendrons pas $name de ce changement."
    override val pageFeedTitle = "Fil"
    override val pageFeedSeoDescription = "Découvre ce que fait la communauté sportive Arena — résultats de matchs, highlights et moments partagés par des joueurs près de chez toi."
    override val pageNoPostsYet = "Pas encore de posts"
    override val pageLoadingMore = "Chargement..."
    override val pagePeopleSeoTitle = "Trouver des joueurs"
    override val pagePeopleSeoDescription = "Découvre des sportifs près de chez toi, matche avec des joueurs de ton niveau et forme une équipe pour ta prochaine partie sur Arena."
    override val pagePeopleTitle = "Joueurs"
    override val pageSquadUpTitle = "Forme ton équipe"
    override val pageSquadUpSubtitle = "Trouve des partenaires, connecte-toi avec des joueurs et lance la partie."
    override val pagePeopleLoadFailed = "Impossible de charger les profils"
    override val pagePeopleCaughtUpTitle = "Tu as tout vu pour le moment"
    override val pagePeopleCaughtUpSubtitle = "Reviens plus tard pour découvrir d'autres joueurs."
    override val pageRefresh = "Actualiser"
    override val pageClientsTitle = "Clients"
    override fun pageClientsTotal(total: Int) = "$total clients au total"
    override val pageActiveClients = "Clients actifs"
    override val pageTotalBookings = "Total des réservations"
    override val pageTotalRevenue = "Revenu total"
    override val pageStatusVip = "VIP"
    override val pageStatusActive = "Actif"
    override val pageStatusDebtor = "Débiteur"
    override val pageStatusAll = "Tous les statuts"
    override val pageStatusInactive = "Inactif"
    override val pageAddNewClient = "Ajouter un client"
    override val pageColName = "Nom"
    override val pageColRevenue = "Revenu"
    override val pageColStatus = "Statut"
    override val pageColLastVisit = "Dernière visite"
    override val pageColActions = "Actions"
    override val pageUnpaidSuffix = "impayé"
    override val pagePrevious = "Précédent"
    override val pagePageLabel = "Page"
    override val pageOfLabel = "sur"
    override val pageBackToEvents = "Retour aux événements"
    override val pageResetTimerTitle = "Réinitialiser le chrono ?"
    override val pageResetTimerMessage = "Le chrono du match sera remis à 00:00. Les statistiques enregistrées restent intactes."
    override val pageResetTimerConfirm = "Réinitialiser"
    override val pageResetting = "Réinitialisation..."
    override val pageEndMatchTitle = "Terminer le match ?"
    override val pageEndMatchMessage = "L'événement sera marqué comme terminé et les scores seront verrouillés."
    override val pageEndMatchConfirm = "Terminer le match"
    override val pageEnding = "Clôture..."
    override val pageAddMedia = "Ajouter des médias"
    override val pageBook = "Réserver"
    override val pageCourtRules = "Règles du terrain"
    override val pageNoCourtRules = "Aucune règle de terrain indiquée."
    override val pageLeaveReview = "Laisser un avis"
    override val pageNoReviewsYet = "Pas encore d'avis."
    override val pageSportFootball = "Football"
    override val pageSportBasketball = "Basketball"
    override val pageSportTennis = "Tennis"
    override val pageSportPadel = "Padel"
    override val pageClubFallback = "Club"
    override fun pageReviewExperienceTitle(sportName: String) = "Comment s'est passée ton expérience $sportName ?"
    override val pageWriteReviewPlaceholder = "Écris ton avis..."
    override val pagePosting = "Publication..."
    override val pagePostReview = "Publier l'avis"
    override val pageLoadMore = "Charger plus"
    override val pageArenaSeoTitle = "Arena"
    override val pageArenaSeoDescription = "Ta carrière sportive en un coup d'œil — statistiques, notes et succès en football, tennis, basketball et plus sur Arena."
    override val pageEventsTab = "Événements"
    override val pageClubsTab = "Clubs"
    override val pageFilterLocation = "Lieu"
    override val pageUnnamedCommunity = "Sans nom"
    override val pageFilterCommunity = "Communauté"
    override val pageFilterAll = "Toutes"
    override val pageFilterCalendar = "Calendrier"
    override val pageAddEvent = "Ajouter un événement"
    override val pageAddClub = "Ajouter un club"
    override val pageMap = "Carte"
    override val pageOwnTheArena = "DOMINE L'ARENA"
    override val pageArenaBannerSubtitle = "Ton arène t'attend. Réserve en un instant — joue en toute confiance."
    override val pageLoadingMoreEvents = "Chargement d'autres événements..."
    override val pageLoadingMoreClubs = "Chargement d'autres clubs..."
    override val pageNoClubsYet = "Pas encore de clubs"
    override val pageClubsWillAppear = "Les clubs apparaîtront ici"
    override val pageEventsMapTitle = "Carte des événements"
    override val pageClubsMapTitle = "Carte des clubs"
    override val pageDeleteClub = "Supprimer le club"
    override val pageAddBanner = "Ajouter une bannière"
    override val pageRulePlaceholder = "ex. Tenue de sport obligatoire"
    override val pageAddRule = "Ajouter une règle"
    override val pageEditServices = "Modifier les services"
    override val pageManageServices = "Gérer les services"
    override val pageAmenityParking = "Parking"
    override val pageAmenityCafe = "Café"
    override val pageAmenityWifi = "WiFi"
    override val pageAmenityReception = "Accueil"
    override val pageAmenityShower = "Douche"
    override val pageAmenityFirstAid = "Premiers secours"
    override val pageReviewsLabel = "Avis :"
    override val pageAvgRatingLabel = "Note moy. :"
    override val pageReviewsPlaceholderNote = "Les avis apparaîtront ici dès que les utilisateurs donneront leur retour."
    override val pageClubComposePrompt = "Quoi de neuf dans ton club ?"
    override val pageClubNoPostsHint = "Partage une photo et une petite pensée pour garder le club actif."
    override val pageComposePostTitle = "Rédiger un post"
    override val pagePostContentPlaceholder = "Contenu du post..."
    override fun pageAddImageSlot(slot: Int) = "Ajouter l'image $slot"
    override val pagePostAction = "Publier"
    override val pageEditClubInfo = "Modifier les infos du club"
    override val pageClubNameLabel = "Nom du club"
    override val pageAddressLabel = "Adresse"
    override val pageSearchAddressPlaceholder = "Rechercher une adresse"
    override val pageSaveChanges = "Enregistrer les modifications"

    // account
    override val accountRequiredTitle = "Compte requis"
    override val accountRequiredDescription = "Cette fonctionnalité est réservée aux joueurs inscrits. Connecte-toi avec Google ou Apple pour continuer."
    override val accountRequiredTermsPrefix = "En continuant, tu acceptes nos "
    override val accountRequiredTerms = "Conditions"
    override val accountRequiredPrivacy = "Confidentialité"

    // avatar
    override val avatarGenTitle = "Avatar IA"
    override val avatarGenErrorFileType = "Seuls les fichiers JPEG, PNG et WebP sont autorisés"
    override val avatarGenErrorFileSize = "Le fichier doit faire moins de 30 Mo"
    override val avatarGenGenerating = "Génération…"
    override val avatarGenGenerate = "Générer"
    override fun avatarGenGenerateWithPrice(price: String) = "Générer · $price"
    override val avatarGenGeneratedLook = "Look généré"
    override val avatarGenDropPhotoHere = "Dépose ta photo ici"
    override val avatarGenMaxFileSize = "30 Mo max"
    override val avatarGenReadyToGenerate = "Prêt à générer"
    override val avatarGenCustomPrompt = "Prompt personnalisé"
    override val avatarGenPromptPlaceholder = "Ajoute des détails pour définir le style ..."
    override val avatarGenInfoDefaultBehavior = "Par défaut, l'IA te détoure de la photo et te place sur la carte."
    override val avatarGenInfoPromptIntro = "Dans le prompt, tu peux aussi demander de :"
    override val avatarGenInfoBulletZoom = "Zoomer ou dézoomer sur la silhouette"
    override val avatarGenInfoBulletObject = "Ajouter ou retirer un objet (ex. lunettes de soleil, maillot, ballon, casquette)"
    override val avatarGenOptionalBadge = "(Optionnel)"

    // card
    override val cardLifeTitle = "Donne vie à ta carte"
    override val cardLifeSubtitle = "Crée ton identité visuelle"
    override val cardLifeMyStyles = "Mes styles"
    override val cardLifeSelectToGenerate = "Sélectionne pour générer"
    override val cardLifeActiveCards = "Cartes de profil actives"
    override val cardLifeDragToReorder = "Glisse pour réorganiser"
    override val cardLifeNoTemplates = "Pas encore de modèles de carte. Va en chercher un dans la boutique de cartes."
    override val cardLifeCreatePhoto = "Créer une photo"
    override val cardLifeDeleteCardTitle = "Supprimer la carte ?"
    override val cardLifeDeleteCardMessage = "Cela retire la carte de ta galerie. Le modèle reste dans tes styles."

    // wallet
    override val walletTitle = "Mon portefeuille"
    override val walletCredits = "Crédits"
    override val walletSignInToBuy = "Connecte-toi pour acheter des crédits."
    override fun walletCreditsAdded(amount: Int) = "$amount crédits ajoutés à ton portefeuille."
    override val walletPurchaseFailed = "Échec de l'achat. Réessaie."
    override fun walletBuyFor(price: String) = "Acheter pour $price"
    override val walletBackToPackages = "Retour aux packs"
    override val walletSelectedPack = "Pack sélectionné"
    override fun walletOneTimePurchase(currency: String) = "$currency · Achat unique"
    override val walletCurrentBalance = "Solde actuel"
    override val walletNewBalance = "Nouveau solde"
    override val walletSecuredNote = "Sécurisé · Aucun prélèvement récurrent"
    override val walletPaymentMethod = "Moyen de paiement"
    override val walletOrPayWithCard = "Ou payer par carte"
    override val walletCardNumber = "Numéro de carte"
    override val walletExpiryDate = "Date d'expiration"
    override val walletCvc = "CVC"
    override fun walletConfirmAndPay(price: String) = "Confirmer et payer €$price"

    // complete
    override val completeProfileTitle = "Complète ton profil pour commencer à swiper"
    override val completeProfileDescription = "Complète ton profil pour voir des joueurs de ton niveau qui partagent tes centres d'intérêt."
    override val completeProfileMaybeLater = "Peut-être plus tard"
    override val completeProfileAction = "Compléter le profil"

    // preference
    override val preferenceDetailsTitle = "Détails des préférences"

    // follow
    override val followListFollowers = "Abonnés"
    override val followListFollowing = "Abonnements"
    override val followListNoResults = "Aucun résultat"
    override val followListNoFollowersYet = "Pas encore d'abonnés"
    override val followListNotFollowingAnyoneYet = "Tu ne suis encore personne"
    override val followListUnfollow = "Ne plus suivre"
    override val followListFollow = "Suivre"
    override val followListRemove = "Retirer"
    override val followListDeleted = "Supprimé"

    // top
    override val topUpTitle = "Recharge ton portefeuille"
    override fun topUpNeedMessage(required: String, action: String, balance: String) = "Il te faut $required pour $action, mais ton portefeuille contient $balance."
    override val topUpChooseAmount = "Choisis un montant"
    override val topUpOr = "ou"
    override val topUpCustomAmount = "Montant personnalisé"
    override val topUpEnterAmountPlaceholder = "Saisis le montant"
    override val topUpAction = "Recharger"
    override val topUpFailed = "Échec de la recharge"

    // interactions
    override val interactionsTitle = "Interactions"
    override fun interactionsSubtitle(newLikes: Int, matches: Int) = "$newLikes nouveaux likes · $matches matchs"
    override val interactionsNewLikes = "Nouveaux likes"
    override val interactionsNoNewLikesTitle = "Pas encore de nouveaux likes"
    override val interactionsNoNewLikesMessage = "Quand quelqu'un swipe Oui sur toi, il apparaîtra ici."
    override val interactionsMatches = "Matchs"
    override val interactionsNoMatchesTitle = "Pas encore de matchs"
    override val interactionsNoMatchesMessage = "Swipe Oui sur quelqu'un qui t'a déjà liké pour valider un match."

    // match
    override val matchItsWord = "C'est un"
    override val matchWord = "Match"
    override val matchSubtitle = "C'est le moment de faire connaissance et de planifier votre partie."
    override val matchKeepSwiping = "Continuer à swiper"
    override val matchGoToProfile = "Voir le profil"
    override val matchYouFallback = "Toi"

    // purchase
    override val purchaseCardTitle = "Prendre cette carte ?"
    override val purchaseCardBuying = "Achat…"
    override val purchaseCardBuyNow = "Acheter"

    // post
    override val postCommentsLike = "J'aime"
    override val postCommentsOneLike = "1 J'aime"
    override fun postCommentsLikes(count: Int) = "$count J'aime"
    override val postCommentsInputPlaceholder = "Écris un message…"

    // story
    override fun storySeenBy(count: Int) = "Vu par $count"

    // support
    override val supportTitle = "Contacter le support"
    override val supportIntro = "Dis-nous ce qui n'a pas marché ou ce dont tu as besoin — nous te répondrons par e-mail."
    override val supportEmailLabel = "Ton e-mail"
    override val supportMessageLabel = "Message"
    override val supportMessagePlaceholder = "Décris ton problème…"
    override val supportErrorInvalidEmail = "Saisis une adresse e-mail valide."
    override val supportErrorEmptyMessage = "Écris un message."
    override val supportErrorGeneric = "Une erreur s'est produite. Réessaie."
    override val supportSending = "Envoi…"
    override val supportSendMessage = "Envoyer le message"
    override val supportSentTitle = "Message envoyé !"
    override val supportSentMessage = "Merci de nous avoir contactés — nous te répondrons bientôt par e-mail."

    // person
    override val personDetailTabAbout = "À propos"
    override val personDetailTabPosts = "Posts"
    override val personDetailTabAchievement = "Succès"
    override val personDetailAchievementsComingSoon = "Les succès arrivent bientôt."
    override val personDetailFollowing = "Abonnements"
    override val personDetailFollowers = "Abonnés"
    override val personDetailSportLabel = "Sport :"
    override val personDetailActivityLabel = "Activité :"
    override val personDetailLifestyleLabel = "Style de vie :"
    override val personDetailNoPostsTitle = "Pas encore de posts"
    override val personDetailNoPostsMessage = "Ce joueur n'a encore rien publié."

    // common
    override val commonClose = "Fermer"
    override val commonDone = "Terminé"
    override val commonLoading = "Chargement…"
    override val commonBack = "Retour"
    override val commonSkip = "Passer"

    // profile
    override val profileCardShopLoading = "Chargement..."
    override val profileCardShopEmpty = "Aucune carte disponible"
    override val profileCardShopBuy = "Acheter"
    override val profileCardShopFree = "Gratuit"
    override val profileFormationReservePlate = "Rés"
    override val profileFormationCoach = "Coach"
    override val profileMediaEmpty = "Pas encore de médias"
    override val profileMediaImageAlt = "média"
    override val profileNewsPrompt = "À quoi tu penses ?"
    override val profileNewsLoading = "Chargement..."
    override val profileNewsLoginRequired = "Connecte-toi pour voir tes posts"
    override val profileNewsEmpty = "Pas encore de posts. Partage quelque chose !"
    override val profileNewsPlaceholder = "Écris quelque chose..."
    override val profileNewsPosting = "Publication..."
    override val profileNewsPost = "Publier"
    override val profileRadarTitle = "Radar"
    override val profileRecentMatchesTitle = "Événements récents"
    override val profileRecentMatchesEmptyTitle = "Aucun événement prévu pour l'instant"
    override val profileRecentMatchesEmptyHint = "Choisis un événement à venir et rejoins l'action !"
    override fun profileRecentMatchesSportPro(sport: String) = "$sport · Pro+"
    override val profileRecentMatchesTeamA = "Équipe A"
    override val profileRecentMatchesTeamB = "Équipe B"
    override fun profileRecentMatchesPeopleCount(count: Int) = "$count pers."
    override val profileRecentMatchesWin = "Victoire"
    override val profileRecentMatchesLoss = "Défaite"
    override val profileRecentMatchesDraw = "Nul"
    override val profileRecentMatchesSportFallback = "Sport"
    override val profileRecentMatchesProPlus = "Pro+"
    override fun profileRecentMatchesFormat(format: Int) = "Format $format X $format"
    override fun profileRecentMatchesMembers(count: Int) = "$count membres"
    override val profileShortcutStatistic = "Statistiques"
    override val profileShortcutMedia = "Médias"
    override val profileStatsChartsGoals = "Buts"
    override val profileStatsChartsAssists = "Passes décisives"
    override val profileStatsChartsPerYear = "par an"
    override val profileStatsChartsPerWeek = "par semaine"
    override val profileStatsChartsPerMonth = "par mois"
    override fun profileStatsChartsTitle(stat: String, period: String) = "$stat $period"
    override val profileStatsChartsNoData = "Aucune donnée disponible"
    override val profileTeamEmptyOwnTitle = "Tu n'as pas encore d'équipe"
    override val profileTeamEmptyOtherTitle = "Pas d'équipe"
    override val profileTeamEmptyCreateTeam = "Créer une équipe"
    override val profileTrackerTitle = "Tracker"
    override val profileTrackerWorldMap = "Carte du monde"
    override val profileTeamMatchesEmpty = "Pas encore de matchs"
    override val profileTeamMatchesUpcomingTitle = "Matchs à venir"
    override val profileTeamMatchesUpcomingEmpty = "Aucun match à venir"
    override val profileTeamMatchesVenueAlt = "Lieu"
    override fun profileTeamMatchesTeamsCount(count: Int) = "$count équipes"
    override fun profileTeamMatchesMembersCount(current: Int, total: Int) = "$current/$total membres"
    override fun profileTeamMatchesFormat(format: Int) = "Format ${format}x${format}"
    override val profileTeamOverviewTitle = "Aperçu de l'équipe"
    override val profileTeamOverviewClubTitle = "Club de football"
    override val profileTeamOverviewRating = "Note"
    override val profileTeamOverviewTeamRating = "Note de l'équipe"
    override val profileTeamOverviewStatistics = "Statistiques"
    override val profileTeamOverviewWins = "Victoires"
    override val profileTeamOverviewDraws = "Nuls"
    override val profileTeamOverviewLosses = "Défaites"
    override val profileSidebarTitle = "Aperçu"
    override val profileSidebarFollowing = "Abonnements"
    override val profileSidebarFollowers = "Abonnés"
    override val profileSidebarAchievement = "Succès"
    override val profileSidebarAboutYouEmpty = "Ajoute quelques mots sur toi pour présenter ton profil"
    override val profileSidebarFocusActivities = "Focus & activités"
    override val profileSidebarSportLabel = "Sport"
    override val profileSidebarActivityLabel = "Activité"
    override val profileSidebarLifestyleLabel = "Style de vie"
    override val profileSidebarChat = "Chat"
    override val profileSidebarFollow = "Suivre"
    override val profileSidebarUnfollow = "Ne plus suivre"
    override val profileSidebarNoInterests = "Aucun centre d'intérêt ajouté"
    override val profileSidebarNoInterestsBody = "Montre aux autres tes loisirs et tes sports."
    override val profileHubTitle = "Player Hub"
    override val profileHubYourStories = "Tes stories"
    override val profileHubStories = "Stories"
    override val profileHubCardShopUnavailable = "Boutique de cartes indisponible"
    override val profileHubCardShopTitle = "Boutique de cartes"
    override val profileHubCardShopSubtitle = "Achète de nouvelles cartes. Définis ton style."
    override val profileHubActiveBought = "Actives & achetées"
    override fun profileHubOwnedCount(count: Int) = "$count possédées"
    override val profileHubNoCardsYet = "Pas encore de cartes"
    override val profileHubAvailableForPurchase = "Disponibles à l'achat"
    override val profileHubNewDesignsRegularly = "De nouveaux designs régulièrement"
    override val profileHubAllCardsOwned = "Toutes les cartes possédées"
    override fun profileHubChartTitle(stat: String, period: String) = "$stat par $period"
    override val profileHubNoChartsTitle = "Aucun graphique disponible"
    override val profileHubNoChartsBody = "Choisis un sport dans l'en-tête pour voir les buts, passes décisives, matchs et le reste de tes statistiques."
    override val profileHubContentTitle = "Contenu"
    override val profileHubLoading = "Chargement..."
    override val profileHubAddStory = "Ajouter une story"
    override val profileHubAddPost = "Ajouter un post"
    override val profileHubUserFallback = "utilisateur"
    override val profileHubNoPostsYet = "Pas encore de posts"
    override val profileHubShareFirstMoment = "Partage ton premier moment"
    override val profileHubPlayerNotPosted = "Ce joueur n'a encore rien publié."
    override val profileOverviewTitle = "Aperçu du joueur"
    override val profileOverviewPlayerIdentify = "Identité du joueur"
    override val profileOverviewChat = "Chat"
    override val profileOverviewAiAvatar = "Avatar IA"
    override val profileOverviewGoals = "Buts"
    override val profileOverviewGoalsUnit = "buts"
    override val profileOverviewWins = "Victoires"
    override val profileOverviewWinsUnit = "victoires"
    override val profileOverviewDraws = "Nuls"
    override val profileOverviewDrawsUnit = "nuls"
    override val profileOverviewLosses = "Défaites"
    override val profileOverviewLossesUnit = "défaites"
    override val profileOverviewAchievements = "Succès"
    override val profileOverviewNotFollowingAnyone = "Tu ne suis encore personne"
    override val profileOverviewComingSoon = "Bientôt disponible"
    override val profileAwardsEmpty = "Pas encore de récompenses"
    override val awardWelcomeTitle = "Récompense de bienvenue"
    override val awardTermScorerFootball = "Meilleur buteur"
    override val awardTermAssistFootball = "Meilleur passeur"
    override val awardTermScorerBasketball = "Meilleur marqueur"
    override val awardTermAssistBasketball = "Meilleur passeur"
    override val awardTermScorerTennis = "Plus de coups gagnants"
    override val awardTermAssistTennis = "Plus d'aces"
    override val awardTermScorerVolleyball = "Meilleur attaquant"
    override val awardTermAssistVolleyball = "Meilleur passeur"
    override val awardTermScorerPadel = "Plus de coups gagnants"
    override val awardTermAssistPadel = "Plus de smashs"
    override val awardTermScorerGeneric = "Meilleur buteur"
    override val awardTermAssistGeneric = "Meilleur passeur"
    override val awardRank1 = "1re place"
    override val awardRank2 = "2e place"
    override val awardRank3 = "3e place"
    override val profileOverviewAddPost = "Ajouter un post"
    override val profileOverviewWritePlaceholder = "Écris quelque chose..."
    override val profileOverviewPost = "Publier"
    override val profileOverviewLoading = "Chargement..."
    override val profileOverviewLoginToSeePosts = "Connecte-toi pour voir les posts"
    override val profileOverviewNoPostsYet = "Pas encore de posts"
    override val profileWizardLetsGo = "C'est parti !"
    override val profileWizardStepPersonalInfoTitle = "Infos personnelles"
    override val profileWizardStepPersonalInfoDescription = "Parle de toi pour commencer."
    override val profileWizardStepFocusTitle = "Focus & activités"
    override val profileWizardStepFocusDescription = "Choisis tes sports et ton style de vie"
    override val profileWizardStepCardTitle = "Donne vie à ta carte"
    override val profileWizardStepCardDescription = "Crée ton identité visuelle"
    override fun profileWizardSelectedCount(count: Int) = "$count sélectionné(s)"
    override val profileWizardPublicInfo = "Infos publiques"
    override val profileWizardMyStyles = "Mes styles"
    override val profileWizardSelectToGenerate = "Sélectionne pour générer"
    override val profileWizardNoTemplates = "Aucun modèle de carte disponible pour l'instant."
    override val profileWizardActiveCards = "Cartes de profil actives"
    override val profileWizardDragToReorder = "Glisse pour réorganiser"
    override fun profileWizardCardCount(count: Int) = "$count carte${if (count == 1) "" else "s"}"
    override val profileWizardCreatePhoto = "Créer une photo"
    override val profileFocusEditTitle = "Focus & activités"
    override val profileFocusEditDescription = "Choisis tes sports et ton style de vie pour façonner ton identité."
    override val profileFocusEditSelectedLabel = "sélectionné(s)"
    override val profileFocusEditClearAll = "Tout effacer"
    override val profileFocusEditSearchPlaceholder = "Rechercher des attributs…"
    override val profileFocusEditSportLabel = "Sport"
    override val profileFocusEditActivityLabel = "Activité"
    override val profileFocusEditLifestyleLabel = "Style de vie"
    override val profileFocusEditNoMatches = "Aucune correspondance"
    override val profileFocusEditPreferenceDetails = "Détails des préférences"
    override val profileFocusEditPreferenceHint = "Optionnel, mais t'aide à trouver plus vite des personnes qui te ressemblent."
    override val profileFocusEditNoteLabel = "Note"
    override val profileFocusEditNotePlaceholder = "Qu'est-ce que tu recherches ?"
    override val profileFocusEditAddDetails = "Ajouter des détails"
    override val profilePersonalEditTitle = "Infos personnelles"
    override val profilePersonalEditDescription = "Parle de toi pour commencer."
    override val profilePersonalEditFirstNameLabel = "Prénom"
    override val profilePersonalEditLastNameLabel = "Nom"
    override val profilePersonalEditAboutMeLabel = "À propos de moi"
    override val profilePersonalEditBioPlaceholder = "Parle un peu de toi aux autres joueurs…"
    override val profilePersonalEditDobLabel = "Date de naissance"
    override val profilePersonalEditCityLabel = "Ville"
    override val profilePersonalEditCitySearchPlaceholder = "Rechercher une ville…"
    override val profilePersonalEditLanguagesLabel = "Langues"
    override val profilePersonalEditTypeLanguagePlaceholder = "Saisis une langue…"
    override val profilePersonalEditAddLanguagePlaceholder = "Ajouter une langue…"
    override val profileEditSheetPublicInfo = "Infos publiques"
    override val profileEditShellPublicInfo = "Infos publiques"
    override fun profileCreatePostAddAllPhotos(count: Int) = "Ajouter les $count photo(s)"
    override val profileCreatePostUploadFailed = "Échec de l'envoi"
    override val profileCreatePostCreateFailed = "Impossible de créer le post"
    override val profileCreatePostTitle = "Créer un post"
    override val profileCreatePostChooseLayout = "Choisir une mise en page"
    override val profileCreatePostFileTooLarge = "Fichier trop volumineux (50 Mo max)"
    override val profileCreatePostCreating = "Création..."
    override val profileCreatePostAddPhoto = "Ajouter une photo"
    override val profileCreatePostContentLabel = "Contenu du post"
    override val profileCreatePostContentPlaceholder = "Écris quelque chose sur ce post..."
    override val profileCreatePostCityLabel = "Ville"
    override val profileCreatePostCityPlaceholder = "Saisis le nom de la ville..."
    override val profileCreateStoryPickPhotoFirst = "Choisis d'abord une photo"
    override val profileCreateStoryUploadFailed = "Échec de l'envoi"
    override val profileCreateStoryCreateFailed = "Impossible de créer la story"
    override val profileCreateStoryTitle = "Créer des stories"
    override val profileCreateStorySubtitle = "Crée et partage tes moments"
    override val profileCreateStoryFileTooLarge = "Fichier trop volumineux (30 Mo max)"
    override val profileCreateStoryCreating = "Création..."
    override val profileCreateStoryDropHere = "Dépose ton contenu ici"
    override val profileCreateStoryMaxSize = " 30 Mo max"
    override val profileFollowListFollowers = "Abonnés"
    override val profileFollowListFollowing = "Abonnements"
    override val profileFollowListNoResults = "Aucun résultat"
    override val profileFollowListUnfollow = "Ne plus suivre"
    override val profileFollowListFollow = "Suivre"
    override val profileFollowListRemoved = "Retiré"
    override val profileFollowListRemove = "Retirer"
    override val profileFollowListNotFollowingTitle = "Tu ne suis encore personne"
    override val profileFollowListNotFollowingBody = "Suis des joueurs pour voir leurs derniers posts de match, highlights et stories dans ton fil."
    override val profileFollowListDiscoverPlayers = "Découvrir des joueurs"
    override val profileFollowListNoFollowersTitle = "Pas encore d'abonnés"
    override val profileFollowListNoFollowersBody = "Partage tes posts de match et tes stories pour te faire remarquer par la communauté."
    override val profileDialogPreferenceDetails = "Détails des préférences"
    override val profileStoryViewersTitle = "Qui a vu cette story ?"
    override val profileStoryViewersNoViews = "Pas encore de vues"
    override val profileContentMobileOverview = "Aperçu"
    override val profileContentMobileFollowing = "Abonnements"
    override val profileContentMobileFollowers = "Abonnés"
    override val profileContentMobileAwardsComingSoon = "Récompenses bientôt disponibles"
    override val profileContentMobileRecentEvents = "Événements récents"
    override val profileContentMobileNoEvents = "Aucun événement prévu pour l'instant"
    override val profileContentMobileNoEventsBody = "Choisis un événement à venir et rejoins l'action !"
    override val profileContentMobileResultWin = "Victoire"
    override val profileContentMobileResultDraw = "Nul"
    override val profileContentMobileResultLoss = "Défaite"
    override val profileContentMobileSportFallback = "Sport"
    override fun profileContentMobileFormat(format: Int) = "Format $format X $format"
    override fun profileContentMobileMembers(count: Int) = "$count membres"
    override val profileContentMobilePlayerHub = "Player Hub"
    override val profileContentMobileNoPostsTitle = "Pas encore de posts"
    override val profileContentMobileNoPostsOwnBody = "Partage des photos de match et des highlights pour remplir ton profil."
    override val profileContentMobileNoPostsOtherBody = "Ce joueur n'a encore rien publié."
    override val profileContentMobileCardsUnavailable = "Cartes indisponibles"
    override val profileContentMobileCardsLoadFailed = "Impossible de charger les cartes"
    override val profileContentMobileNoCardsAvailable = "Aucune carte disponible"
    override val profileContentMobileActiveBought = "Actives & achetées"
    override fun profileContentMobileOwnedCount(count: Int) = "$count possédées"
    override val profileContentMobileAvailableForPurchase = "Disponibles à l'achat"
    override val profileContentMobileNewDesigns = "De nouveaux designs régulièrement"
    override val profileContentMobileNoCardsYet = "Pas encore de cartes"
    override val profileContentMobileCardsTitle = "Cartes"
    override val profileContentMobileAddPost = "Ajouter un post"
    override val profileContentMobileUserFallback = "utilisateur"
    override val profileUserSheetError = "Une erreur s'est produite"
    override val profileUserSheetThisUser = "cet utilisateur"
    override fun profileUserSheetUnfollowTitle(name: String) = "Ne plus suivre $name ?"
    override val profileUserSheetRefollowHint = "Tu peux te réabonner à tout moment."
    override val profileUserSheetUnfollow = "Ne plus suivre"

    // header
    override val headerNavHome = "Accueil"
    override val headerNavAbout = "À propos"
    override val headerNavServices = "Services"
    override val headerNavProjects = "Projets"
    override val headerNavContacts = "Contacts"
    override val headerSportLabel = "Sport :"
    override val headerUserFallbackName = "Utilisateur"
    override val headerNoActiveEvents = "Aucun événement ou réservation en cours"
    override val headerNoNotifications = "Aucune notification"
    override val headerYourActiveEvents = "Tes événements actifs "
    override val headerNotificationsTitle = "Notifications "
    override val headerMarkAllRead = "Tout marquer comme lu"
    override val headerLoadMore = "Charger plus"
    override val headerPendingApproval = "En attente d'approbation"
    override val headerEventStatusNew = "Nouveau"
    override val headerEventStatusInProgress = "En cours"
    override val headerEventStatusCompleted = "Terminé"
    override val headerEventStatusCancelled = "Annulé"
    override val headerBookingFallback = "Réservation"
    override val headerActionView = "Voir"
    override val headerActionReply = "Répondre"
    override val headerActionUnfollow = "Ne plus suivre"
    override val headerActionFollowBack = "Suivre en retour"
    override val headerActionAccept = "Accepter"
    override val headerActionDecline = "Refuser"
    override val headerConfirmTitle = "Tu es sûr ?"
    override val headerSignOutConfirmMessage = "Tu seras déconnecté d'Arena sur cet appareil. Tes données restent en sécurité."
    override val headerSignOutConfirmLabel = "Se déconnecter"
    override val headerDeleteConfirmMessage = "La suppression de ton profil est définitive. Tous les crédits, moments et statistiques seront effacés."
    override val headerDeleteConfirmLabel = "Confirmer la suppression"
    override val headerDeleteProfileFailed = "Impossible de supprimer ton profil. Réessaie."
    override val headerUploading = "Envoi en cours..."
    override val headerVisualStyle = "Style visuel"
    override val headerSyncWithSportType = "Synchroniser avec le sport"
    override val headerMyWallet = "Mon portefeuille"
    override val headerSignOut = "Se déconnecter"
    override val headerSigningOut = "Déconnexion..."
    override val headerDeleteProfile = "Supprimer le profil"
    override val headerRequestNoLongerAvailable = "Cette demande n'est plus disponible."
    override val headerRequestProcessFailed = "Impossible de traiter la demande. Réessaie."
    override val headerSelectClub = "Sélectionner un club"
    override val headerAddClub = "Ajouter un club"
    override val headerSwitchToPlayer = "Passer en mode joueur"
    override val headerLogout = "Se déconnecter"
    override val headerLoggingOut = "Déconnexion..."
    override val headerSigningIn = "Connexion..."

    // home
    override val homeHeroBrand = "Arena Pro Play"
    override val homeHeroUnites = "réunit"
    override val homeHeroAthletes = "les athlètes"
    override val homeHeroAndTeams = "et les équipes"
    override val homeHeroWorldwideFor = "dans le monde entier pour"
    override val homeSectionCreateEventsTitle = "Crée des événements"
    override val homeSectionCreateEventsHighlight = "événements"
    override val homeSectionCreateEventsSubtitle1 = "Choisis le sport, définis le planning"
    override val homeSectionCreateEventsSubtitle2 = "et ajoute le lieu de la partie."
    override val homeSectionTeammatesTitle = "Trouve les coéquipiers parfaits"
    override val homeSectionTeammatesHighlight = "coéquipiers"
    override val homeSectionMomentsTitle = "Partage des moments, connecte-toi avec des amis"
    override val homeSectionMomentsHighlight = "amis"
    override val homeSectionStatsTitle = "Suis tes stats, ta progression & personnalise ta carte"
    override val homeSectionStatsHighlight = "progression"
    override val homeAltEventsScreen = "Écran des événements"
    override val homeAltCreateEventScreen = "Écran de création d'événement"
    override val homeAltCreateEventModal = "Fenêtre de création d'événement"
    override val homeAltEventDetailScreen = "Écran de détail d'événement"
    override val homeAltDiscoverPeople = "Découvrir des joueurs"
    override val homeAltPlayerDiscoveryCard = "Carte de découverte de joueur"
    override val homeAltMatchedInterests = "Centres d'intérêt en commun"
    override val homeAltMatchedInterestsModal = "Fenêtre des centres d'intérêt en commun"
    override val homeAltItsAMatch = "C'est un match"
    override val homeAltFeedScreen = "Écran du fil"
    override val homeAltFeedPost = "Post du fil"
    override val homeAltGameMomentsPost = "Post de moments de jeu"
    override val homeAltChatScreen = "Écran du chat"
    override val homeAltProfileOverview = "Aperçu du profil"
    override val homeAltProfileDashboard = "Tableau de bord du profil"
    override val homeAltPlayerStatsRadar = "Radar des stats du joueur"
    override val homeAltPlayerStatsCard = "Carte des stats du joueur"
    override val homeAltRatePerformance = "Noter la performance"
    override val homeAltRatePerformanceModal = "Fenêtre de notation de la performance"
    override val homeItsYourMatch = "C'est ton match !"
    override val homeLabelGameMoments = "Moments de jeu"
    override val homeLabelPlayerStats = "Stats du joueur"
    override val homeLabelRatePerformance = "Noter la performance"
    override val homeFooterTagline = "Ta communauté sportive mondiale"
    override val homeFooterBlurb = "Trouve des gens près de chez toi pour jouer au football, tennis, basketball, padel ou volleyball — rejoins des parties improvisées et des événements sportifs locaux, ou crée les tiens sur Arena."
    override val homeFooterAbout = "À propos"
    override val homeFooterTerms = "Conditions d'utilisation"
    override val homeFooterPrivacy = "Politique de confidentialité"
    override val homeFooterPricing = "Tarifs"
    override val homeFooterRefund = "Politique de remboursement"
    override val homeFooterSupports = "Support"
    override val homeFooterCopyright = "© 2026 Arena Pro Play"
    override val homeStoreAppleEyebrow = "TÉLÉCHARGER SUR"
    override val homeStoreAppleName = "Apple Store"
    override val homeStoreGoogleEyebrow = "DISPONIBLE SUR"
    override val homeStoreGoogleName = "Google Play"

    // dashboard
    override val dashboardTabAnalytics = "Analyses"
    override val dashboardTabSchedule = "Planning"
    override val dashboardRatingTitle = "Note"
    override val dashboardReviews = "avis"
    override val dashboardAvgDuration = "Durée moy."
    override val dashboardTotalRevenue = "Revenu total"
    override val dashboardTotalBookings = "Total des réservations"
    override val dashboardArenaSchedule = "Planning de l'arène"
    override val dashboardThisWeek = "Cette semaine"
    override val dashboardAddEvent = "Ajouter un événement"
    override val dashboardTimeHeader = "Heure"
    override val dashboardCustomerFallback = "Client"
    override val dashboardRevenueTitle = "Revenu"
    override val dashboardBookingsTitle = "Réservations"
    override val dashboardBookingStatusTitle = "Statut des réservations"
    override val dashboardBookingHeatmapTitle = "Carte de chaleur des réservations"
    override val dashboardDonutTotal = "Total"
    override val dashboardBookingsTooltipPrefix = "Réservations "
    override val dashboardStatusConfirmed = "Confirmées"
    override val dashboardStatusCompleted = "Terminées"
    override val dashboardStatusPending = "En attente"
    override val dashboardStatusUnpaid = "Impayées"
    override val dashboardStatusDeclined = "Refusées"
    override val dashboardNoData = "Aucune donnée"
    override val dashboardDayMon = "Lun"
    override val dashboardDayTue = "Mar"
    override val dashboardDayWed = "Mer"
    override val dashboardDayThu = "Jeu"
    override val dashboardDayFri = "Ven"
    override val dashboardDaySat = "Sam"
    override val dashboardDaySun = "Dim"
    override fun dashboardHourLabel(hour: Int) = "${hour}h"
    override fun dashboardHeatmapTooltip(day: String, fromHour: Int, toHour: Int, count: Int) = "$day $fromHour:00–$toHour:00 · $count réservations"

    // arena
    override val arenaActionViewResults = "Voir les résultats"
    override val arenaActionWatchLive = "Regarder en direct"
    override val arenaActionJoinNow = "Rejoindre"
    override val arenaStatusLive = "Live"
    override val arenaStatusNew = "Nouveau"
    override val arenaStatusCompleted = "Terminé"
    override val arenaStatusCanceled = "Annulé"
    override fun arenaMembersJoinedTotal(joined: Int, total: Int) = "$joined / $total membres"
    override fun arenaMembersCount(count: Int) = "$count membres"
    override fun arenaTeamsCount(count: Int) = "$count équipes"
    override fun arenaFormat(format: String) = "Format $format"
    override fun arenaFinalScore(score: String) = "Score final $score"
    override fun arenaDuration(duration: String) = "Durée $duration"
    override val arenaLoadingClubs = "Chargement des clubs..."
    override val arenaLoadingMoreEvents = "Chargement d'autres événements..."
    override val arenaLoadingMoreClubs = "Chargement d'autres clubs..."
    override val arenaLocationLabel = "Lieu : "
    override val arenaAllCities = "Toutes les villes"
    override val arenaCommunityAll = "Toutes"
    override val arenaCommunityUnnamed = "Sans nom"
    override val arenaTabClubs = "Clubs"
    override val arenaTabEvents = "Événements"
    override val arenaEmptyTitle = "Aucun événement prévu pour l'instant"
    override val arenaEmptySubtitle = "Crée un événement pour le chat de match et le suivi en temps réel."
    override val arenaAddEvent = "Ajouter un événement"
    override val arenaNoClubsTitle = "Pas encore de clubs"
    override val arenaNoClubsSubtitle = "Les clubs apparaîtront ici"

    // people
    override val peopleErrorLoad = "Impossible de charger les profils"
    override val peopleCaughtUpTitle = "Tu as tout vu"
    override val peopleCaughtUpSubtitle = "Reviens plus tard pour découvrir d'autres joueurs."
    override val peopleRefresh = "Actualiser"
    override val peopleBadgeLike = "LIKE"
    override val peopleBadgeNope = "NOPE"
    override fun peopleNameAge(name: String, age: Int) = "$name, $age"

    // feed
    override val feedEmptyTitle = "Ton fil est vide"
    override val feedEmptySubtitle = "Suis des joueurs pour voir leurs posts et stories ici."
    override val feedNoCommentsTitle = "Pas encore de commentaires"
    override val feedNoCommentsSubtitle = "Sois le premier à commenter."
    override val feedMessagePlaceholder = "Écris un message..."
    override val feedLikeZero = "J'aime"
    override val feedLikeOne = "1 J'aime"
    override fun feedLikeMany(count: Int) = "$count J'aime"

    // auth
    override val authWelcomeTitle = "Bienvenue dans l'Arena !"
    override val authWelcomeSubtitle = "Connecte-toi avec Google ou Apple pour créer ton profil, débloquer cette page et commencer ton aventure sportive avec nous."
    override val authAgreePrefix = "En continuant, tu acceptes nos"
    override val authTerms = "Conditions"
    override val authPrivacy = "Confidentialité"

    // layout
    override val layoutComingSoon = "Bientôt disponible"
}
